/* istanbul ignore file */

export const isInIframe = () => {
	try {
		return window.self !== window.top;
	} catch {
		return true;
	}
};

export const isBroadcastChannelSupported = () =>
	typeof BroadcastChannel !== 'undefined';
